<template>
  <div :class="$style.footer">
    <div :class="$style.footerInner">
      <p class="mb-0" style="color: black;">
        <b>EROO :: ERP para Instituciones Educativas.</b>
      </p>
      <p class="mb-0 mt-0">
        {{ schoolName }}
      </p>
    </div>
  </div>
</template>

<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import store from 'store'

export default {
  name: 'schoolSettings',
  data() {
    return {
      schoolName: '',
      accessToken: '',
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.accessToken = store.get('accessToken')
    apiClient.get('/schools/' + this.$store.state.user.idSchool).then(response => {
      this.schoolName = response.data.name
    }).catch(e => {
      console.log(e.response)
    })
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
